import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { TalentPoolData } from '@core/tellent-assistant-types';
import { IconContainerComponent } from '@core/user-interface-legacy';

import { ListCardComponent } from '../../list-card/list-card.component';

@Component({
  selector: 'rt-list-item-talent-pool',
  imports: [ListCardComponent, IconContainerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-talent-pool.component.html',
  styleUrl: './list-item-talent-pool.component.less',
})
export class ListItemTalentPoolComponent {
  public readonly data = input.required<TalentPoolData>();
}
